import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SiteDashboardService } from '../site-dashboard.service';
import { CommonService, TimeSource } from 'src/app/shared/services/common.service';
import { UsersService } from 'src/app/users/users.service';
import { SitesService } from 'src/app/sites/sites.service';
import { DeviceService } from '../device/device.service';
import * as moment from 'moment';
import * as _ from 'underscore';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { SideMenuService } from 'src/app/shared/side-menu/side-menu.service';
import { ColumnsConfig, TableConfig, TableData} from 'sct-custom-table/sct-table/projects/sct-table/src/lib/custom-table-interface';
import { DeviceFactory } from '../device/device-factory/device-factory';
import { DomainsService } from 'src/app/shared/services/domains.service';
import { keyBy } from 'lodash-es';
import { ModalComponent } from 'src/app/shared/modal/modal.component';
import { NotificationMessageService } from 'src/app/shared/notification-message/notification-message.service';
import { MailerSubscriptionService } from 'src/app/shared/services/mailer-subscription.service';
import { DecimalPipe } from '@angular/common';
import { v4 as uuid } from 'uuid';
import { DeviceCommonService } from '../device/device-common.service';

@Component({
	selector: 'app-site-info',
	templateUrl: './site-info.component.html',
	styleUrls: ['./site-info.component.css']
})
export class SiteInfoComponent implements OnInit, OnDestroy {
	deviceFactory = DeviceFactory;
	siteInfo: any = {};
	permissions: any = {};
	sitePermissions: any = {};

	devices = [];
	IoTAhDevices = [];
	chargeLinkDevices = [];
	battlinkDevices = [];
	allBattlinkDevices = [];
	meteredDevices = [];
	dots = [];

	uniqueIPaddresses = [];
	showOnlyConnected = false;
	liveSiteTimeInterval;
	liveSiteTime;
	zoneName;
	currentUser: any = {};
	whrsUnit;
	whrsUsed;
	ahrsUnit;
	ahrsUsed;
	hoursUsed;
	infoBoxSiteAnalytics: any = {};

	siteDevicesAnalytics: any = {};

	isProduction: boolean = false;

	minDate!: Date;
	minDateChargersDevices!: Date;

	monthsOption: any[] = [];
	chargLinkMonthsOption: any[] = [];
	chargLinkQuartersOption: any[] = ['Q1', 'Q2', 'Q3', 'Q4'];

	yearsOption: any[] = [];
	chargLinkYearsOption: any[] = [];

	// Quarterly Charge Usage Report ( IoTAh )
	quarterData: any;
	monthData: any;
	quartersList: any[] = [];
	monthsList: any[] = [];
	truckYearsList: any[] = [];

	summaryTruckUsageReport = {
		column: [
			{ key: 'truck_id', name: this.translateService.instant('devices.truck_id'), type: 'link'},
			{ key: 'truck_sn', name: this.translateService.instant('devices.truck_sn'), type: 'link'},
			{ key: "truck_type", name: this.translateService.instant("devices.truck_type"), type: 'string' },
			{ key: "drive_hours", name: this.translateService.instant("site.drive_hours"), type: 'string' },
			{ key: "lift_hours", name: this.translateService.instant("site.lift_hours"), type: 'number' },
			{ key: "deadman_hours", name: this.translateService.instant("site.deadman_hours"), type: 'number' },
			{ key: "idle_hours", name: this.translateService.instant("site.idle_hours"), type: 'number' },
			{ key: "off_charge_hours", name: this.translateService.instant("site.off_charge_hours"), type: 'number' },
			{ key: "inuse_ah", name: this.translateService.instant("events.inuse_ahr"), type: 'number' },
			{ key: "inuse_kwh", name: this.translateService.instant("events.inuse_kwhr"), type: 'number' },
		],
		data: [],
		config: {
			hasExport: true,
			hasPagination: false,
			draggable: true,
			fileName: this.translateService.instant('site.summary_truck_usage_report_title')
		} as TableConfig
	};

	installedIotahDeviceTableConfig = {
		column: [] as ColumnsConfig[],
		data: [],
		config: {
			hasExport: true,
			hasPagination: true,
			draggable: true,
			fileName: this.translateService.instant('site.site_devices')
		} as TableConfig
	};

	installedChargerDeviceTableConfig = {
		column: [] as ColumnsConfig[],
		data: [],
		config: {
			hasExport: true,
			hasPagination: true,
			draggable: true,
			pageSize: 100,
			fileName: this.translateService.instant('chargLinkDevice.site.site_devices')
		} as TableConfig
	};

	installedIotemeterDeviceTableConfig = {
		column: [] as ColumnsConfig[],
		data: [],
		config: {
			hasExport: true,
			hasPagination: true,
			draggable: true,
			pageSize: 100,
			fileName: this.translateService.instant('iotemeter.site.site_devices')
		} as TableConfig
	};

	chargLinkQuarterlyTableConfig = {
		column: [] as ColumnsConfig[],
		data: [],
		config: {
			hasExport: true,
			hasPagination: true,
			draggable: true,
			pageSize: 100,
			fileName: this.translateService.instant('site.chargLinkeQuarterly_site_report_title'),
		} as TableConfig
	};

	selectedMonthData: any[];
	selectedYearQ: any;
	selectedQuarter: any;
	selectedMonth: any;
	selectedTruckYear: any = 'all';

	truckInventoryReport = {
		column: [] as ColumnsConfig[],
		data: [],
		config: {
			hasExport: true,
			hasPagination: true,
			draggable: true,
			pageSize: 100,
			fileName: this.translateService.instant('site.ioTAh_devices.truck_inventory_report')
		} as TableConfig
	};

	// Quarterly Charge Usage Report ( ChargLink )
	chargLinkQuarterlyReportCols: any[] = [];
	chargLinkQuarterData: any;
	chargLinkQuartersList: any[] = [];

	charglinkSelectedQuarterData: any[];
	chargLinkSelectedQuarter: any;
	chargLinkSelectedYear: any;

	contactInfo: any[] = [];
	sctDeviceType = DeviceFactory.types.iotah;
	tooltips = {
		quarterly_site_report: '',
		chargLink_quarterly_site_report: '',
		site_devices: '',
		chargLink_site_devices: '',
		battlink_site_devices: '',
		site_info: '',
		chargLink_site_info: '',
		truck_inventory_report: '',
		charger_inventory_report: '',
		battlink_inventory_report: '',
		summary_truck_usage_report: '',
		summary_charger_usage_report: '',
		summary_battlink_usage_report: '',
		low_charger_utilization_report: '',
		battery_replacement_report: '',
	};

	tags: any[];
	deviceTags: any[];
	infoBox;
	imDomain: string;
	status = {
		failed: this.translateService.instant(`g.failed`),
		passed: this.translateService.instant(`g.passed`),
		not_tested: this.translateService.instant(`g.not_tested`),
	}

	permissionsSub: Subscription = new Subscription();

	selectedDataOption = 'since_installation';

	siteId!: number;
	siteZoneId!: number;
	selectedYearUsageReport!: number;
	chargLinkSelectedYearUsageReport!: number;
	currentSiteName!: string;
	currentSiteAddress!: string;
	siteUTCDifference = '';
	brmValidToken = false;
	currentSiteUrl: string = window.location.origin;

	chargersDevices: any[] = [];
	chargerInventoryReportTableConfig = {
		column: [] as ColumnsConfig[],
		data: [],
		config: {
			hasExport: true,
			hasPagination: true,
			draggable: true,
			pageSize: 100,
			fileName: this.translateService.instant('chargLinkDevice.site.charger_inventory_report')
		} as TableConfig
	};

	periodTypes = {
		all_year: 0,
		quarter: 1,
		month: 2,
	};

	periodTypesItems = [
		{ id: this.periodTypes.all_year, label: this.translateService.instant('g.all_year_option') },
		{ id: this.periodTypes.quarter, label: this.translateService.instant('g.quarter_option') },
		{ id: this.periodTypes.month, label: this.translateService.instant('g.month_option') },
	];

	chargLinkSelectedMonth: any;
	chargeLinkSelectedPeriodType = this.periodTypes.all_year;

	lowChargerUtilizationReportTableConfig = {
		column: [
			{ key: 'truck_id', name: this.translateService.instant('chargLinkDevice.devices.truck_id'), type: 'string' },
			{ key: 'truck_sn', name: this.translateService.instant('devices.charger_serial_number'), type: 'link' },
			{ key: 'charger_type', name: this.translateService.instant('chargLinkDevice.devices.truck_type'), type: 'string' },
			{ key: 'score', name: this.translateService.instant('devices.charger_utilization_score'), type: 'string' },
		],
		data: [],
		config: {
			hasExport: true,
			hasPagination: true,
			draggable: true,
			pageSize: 100,
			fileName: this.translateService.instant('chargLinkDevice.site.low_charger_utilization_report')
		} as TableConfig
	};

	timePeriodFilters = [
		{ value: 'last_week', label: this.translateService.instant('durations.last_week') },
		{ value: 'last_7_days', label: this.translateService.instant('durations.last_7_days') },
		{ value: 'last_30_days', label: this.translateService.instant('durations.last_30_days') },
		{ value: 'last_90_days', label: this.translateService.instant('durations.last_90_days') },
		{ value: 'year_to_date', label: this.translateService.instant('durations.year_to_date') },
		{ value: 'last_year', label: this.translateService.instant('durations.last_year') },
		{ value: 'since_installation', label: this.translateService.instant('durations.all_years') },
	];
	selectedTimePeriodFilters = this.timePeriodFilters[0].value;

	isShownMap: boolean = false;
	truckTypeList: Array<{label: string, value: string}> = [
		{value: 'all', label: this.translateService.instant('site_performance.all_truck_types')}
	];

	selectedTruckType = this.truckTypeList[0].value;
	selectedSummaryTruckUsageFilter = this.timePeriodFilters[0].value;
	selectedSummaryTruckTypeFilter = this.truckTypeList[0].value;
	siteDevicesAnalyticsData: any = {};

	/* BattLink Reports */
	batteryInventoryReport = {
		column: [
			{ key: 'truck_id', name: this.translateService.instant('battlinkDevice.devices.truck_id'), type: 'string'},
			{ key: 'truck_sn', name: this.translateService.instant('battlinkDevice.smart_rebates_reports.truck_sn'), type: 'link'},
			{ key: 'truck_manufacturer', name: this.translateService.instant('battlinkDevice.devices.truck_manufacturer'), type: 'string'},
			{ key: "_voltage", name: this.translateService.instant("battlinkDevice.devices.battery_voltage"), type: 'number' },
			{ key: "battery_capacity", name: this.translateService.instant("devices.battery_capacity"), type: 'number' },
			{ key: "truck_manufacturing_date", name: this.translateService.instant("battlinkDevice.devices.truck_manufacturing_date"), type: 'string' },
			{ key: "last_longitude", name: this.translateService.instant("battlinkDevice.devices.last_battery_long"), type: 'number' },
			{ key: "last_latitude", name: this.translateService.instant("battlinkDevice.devices.last_battery_lat"), type: 'number' },
			{ key: "last_pm_date", name: this.translateService.instant("site.last_pm_date"), type: 'timestamp', dateFormat: 'MM/DD/YYYY' },
			{ key: "battery_life_remainig_yrs", name: this.translateService.instant("battlinkDevice.devices.battery_life_remainig_yrs"), type: 'number' },
			{ key: "battery_life_remaining_ah", name: this.translateService.instant("battlinkDevice.devices.battery_life_remaining_ah"), type: 'number' },
		],
		data: [] as TableData[],
		config: {
			hasExport: true,
			hasPagination: true,
			draggable: true,
			pageSize: 100,
			fileName: this.translateService.instant('battlinkDevice.site.battery_inventory_report')
		} as TableConfig
	};

	// installed battlink Devices report
	installedBattlinkDevicesReportsConfig = {
		column: [] as ColumnsConfig[],
		data: [] as TableData[],
		config: {
			hasExport: true,
			hasPagination: true,
			draggable: true,
			pageSize: 100,
			fileName: this.translateService.instant('battlinkDevice.site.site_devices')
		} as TableConfig
	};

	// Battlink Replacement Report
	batteryReplacementReport = {
		column: [
			{ key: 'truck_id', name: this.translateService.instant('battlinkDevice.devices.truck_id'), type: 'string'},
			{ key: 'truck_sn', name: this.translateService.instant('battlinkDevice.smart_rebates_reports.truck_sn'), type: 'link'},
			{ key: 'truck_manufacturer', name: this.translateService.instant('battlinkDevice.devices.truck_manufacturer'), type: 'string'},
			{ key: "_voltage", name: this.translateService.instant("battlinkDevice.devices.battery_voltage"), type: 'number' },
			{ key: "battery_capacity", name: this.translateService.instant("devices.battery_capacity"), type: 'number' },
			{ key: "truck_manufacturing_date", name: this.translateService.instant("battlinkDevice.devices.truck_manufacturing_date"), type: 'string' },
			{ key: "battery_life_years", name: this.translateService.instant("battlinkDevice.devices.battery_life_years"), type: 'number' },
			{ key: "battery_life_remainig_yrs", name: this.translateService.instant("battlinkDevice.devices.battery_life_remainig_yrs"), type: 'number' },
			{ key: "battery_life_remaining_ah", name: this.translateService.instant("battlinkDevice.devices.battery_life_remaining_ah"), type: 'number' },
		],
		data: [] as TableData[],
		config: {
			hasExport: true,
			hasPagination: true,
			draggable: true,
			pageSize: 100,
			fileName: this.translateService.instant('battlinkDevice.site.battery_replacement_report')
		} as TableConfig
	};

	batteryCapacityOptions = [
		{ label: 'All', value: 'all' },
		{ label: '20%', value: 20 },
		{ label: '40%', value: 40 },
		{ label: '50%', value: 50 },
		{ label: '60%', value: 60 },
		{ label: '70%', value: 70 },
		{ label: '80%', value: 80 },
		{ label: '100%', value: 100 }
	];

	batteryReplacementYearsOptions = [
		{ label: 'All', value: 'all' },
		{ label: '1', value: 1 },
		{ label: '2', value: 2 },
		{ label: '3', value: 3 },
		{ label: '4', value: 4 },
		{ label: '5', value: 5 }
	];
	selectedBatteryCapacityFilter = this.batteryCapacityOptions[0].value;
	selectedBatteryYearFilter = this.batteryReplacementYearsOptions[0].value;

	//battery summary usage report
	batterySummaryUsage = {
		column: [
			{ key: 'truck_id', name: this.translateService.instant('battlinkDevice.devices.truck_id'), type: 'string'},
			{ key: 'truck_sn', name: this.translateService.instant('battlinkDevice.smart_rebates_reports.truck_sn'), type: 'link'},
			{ key: 'charge_hours', name: this.translateService.instant('fleet_reports.charge_hours'), type: 'number'},
			{ key: 'inuse_hours', name: this.translateService.instant('battlinkDevice.devices.inuse_hours'), type: 'number'},
			{ key: 'idle_hours', name: this.translateService.instant('battlinkDevice.devices.idle_hours'), type: 'number'},
			{ key: 'charge_ah', name: this.translateService.instant('battlinkDevice.devices.charge_ah'), type: 'number'},
			{ key: 'inuse_ah', name: this.translateService.instant('battlinkDevice.devices.inuse_ah'), type: 'number'},
			{ key: 'charge_kwh', name: this.translateService.instant('battlinkDevice.devices.charge_kwh'), type: 'number'},
			{ key: 'inuse_kwh', name: this.translateService.instant('battlinkDevice.devices.inuse_kwh'), type: 'number'},
		],
		data: [] as TableData[],
		config: {
			hasExport: true,
			hasPagination: true,
			draggable: true,
			pageSize: 100,
			fileName: this.translateService.instant('battlinkDevice.site.summary_usage_report')
		} as TableConfig
	};
	batterySummaryCapacityOptions: any[] = [{value: 'all', label: this.translateService.instant('g.all')}];
	batterySummaryVoltageOptions: any[] = [{value: 'all', label: this.translateService.instant('g.all')}];

	selectedBatterySummaryPeriodFilter = this.timePeriodFilters[0].value;
	selectedBatterySummaryVoltageFilter: any;
	selectedBatterySummaryCapacityFilter: any;

	/** Which time zone each time column is rendered in. See ST-2326. */
	private readonly timeSourceByColumn: Record<string, TimeSource> = {
		last_connect_time_formatted: TimeSource.PcTime,
	};

	@ViewChild("revealPasswordConfirmModal") revealPasswordConfirmModal: ModalComponent;

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private translateService: TranslateService,
		private siteDashboardService: SiteDashboardService,
		private common: CommonService,
		public usersService: UsersService,
		public sitesService: SitesService,
		public deviceService: DeviceService,
		public sideMenuService: SideMenuService,
		private domainsService: DomainsService,
		private notificationMessage: NotificationMessageService,
		public mailerSubscriptionService: MailerSubscriptionService,
		private deviceCommonService: DeviceCommonService,
	) { }

	ngOnInit() {
		this.isProduction = this.domainsService.isProductionDomain;

		let fieldsAccess: any = {};
		this.permissionsSub = this.siteDashboardService.permissionsOfCurrentSite.subscribe(data => {
			this.sitePermissions = data;
			for (let key in this.tooltips) {
				this.tooltips[key] = this.common.getTooltipKey(key, this.usersService.userHasNOCAccess(data));
			}
			fieldsAccess = {
				truck_manufacturer: this.usersService.hasAccessPermission(data, 'truck_manufacturer'),
				last_pm_date: this.usersService.hasAccessPermission(data, 'last_pm_date'),
				billed_kwhr: this.usersService.hasAccessFunction('billed_kwhrs_settings'),
				charger_max_power: this.usersService.hasAccessPermission(data, 'basic_setup')
			};
		});

		this.usersService.currentUser.subscribe((user: any) => {
			if (user && user.id) {
				this.currentUser = user;
			}
		});

		const siteId = parseInt(this.route.snapshot.params.siteId);
		const customerId = parseInt(this.route.snapshot.params.customerId);

		if (!siteId || isNaN(siteId)) {
			return this.router.navigateByUrl('/404');
		}

		this.fillChargLinkQuarterlyReportCols(fieldsAccess);

		this.truckYearsList = [];
		for (let item of ['all', 'new', 'old']) {
			this.truckYearsList.push({
				value: item,
				label: this.translateService.instant('site_performance.truck_year_' + item)
			});
		}

		this.siteDashboardService.getSiteData(siteId).subscribe((data: any) => {
			if(data == 'not_found')
				return this.router.navigateByUrl('/404');

			this.handleIotahUsageReportSelectDate(data.site.devices_min_installation_date || 0);
			this.handleChargersUsageReportSelectDate(data.site.devices_min_installation_date_chargLink || 0);

			this.siteInfo = this.common.decompress(data.site, 'site');
			this.common.setPageTabTitle(`${this.siteInfo.customer_name} - ${this.siteInfo.name} Site Info`);
			this.currentSiteName = this.siteInfo.name;
			this.currentSiteAddress = this.siteInfo.address;
			this.siteId = this.siteInfo.id;
			this.siteZoneId = this.siteInfo.zone_id;
			this.sitesService.addSitesConnectivityStatusIcons([this.siteInfo]);
			this.devices = this.formatDeviceFields(data.device, data.permissions);
			this.siteDevicesAnalytics = data.siteDevicesAnalytics;
			this.siteInfo.devices_count = this.devices.length;
			this.permissions = this.common.revertPermissionValue(data.permissions);
			if (this.siteInfo.contact_name)
				this.contactInfo.push(this.siteInfo.contact_name);
			if (this.siteInfo.email)
				this.contactInfo.push(this.siteInfo.email);
			if (this.siteInfo.phone_num)
				this.contactInfo.push(this.siteInfo.phone_num);

			this.liveSiteTimeInterval = setInterval(() => {
				this.liveSiteTime = this.common.getDateFormattedFromUnixTimeStamp(this.common.getZoneTimestampFromUTC(this.siteInfo['zone_id'], moment().utc().unix()));
			}, 500);

			this.zoneName = this.common.getZoneName(this.siteInfo['zone_id']);
			this.showOnlyConnectedIPs(this.showOnlyConnected);

			// separate IoTAh devices from ChargLink devices
			this.filterDevices();

			this.prepareDevicesGridCols();
			this.prepareChargeLinkDevicesGridCols(fieldsAccess);
			this.prepareTruckInventoryReportColumns();
			this.infoBox = data.infoBox;
			this.setInfoBoxSiteAnalyticsData();

			this.prepareQuarterReport(this.siteDevicesAnalytics.usageData.qReport, DeviceFactory.types.iotah);
			this.prepareQuarterReport(this.siteDevicesAnalytics.usageData.qReport, DeviceFactory.types.charglink);

			this.prepareTags(data.siteTags);
			this.setMapDotes();
			if (this.siteInfo.brm_devices_count > 0)
				this.regenerateBrmToken(false);

			// Charger Inventory Report
			this.getChargersDevices(this.devices);
			this.fillChargerInventoryReportTableConfig();

			if (this.IoTAhDevices.length > 0 || this.allBattlinkDevices.length > 0)
				this.getSiteDevicesAnalyticsData();

			// battlink inventory report
			this.prepareBatteryInventoryReport();
			// battlink installed report
			this.prepareInstalledBatteryReport();
			//battery replacement report
			this.getBatteryReplacementReportData();
			this.prepareIotemeterInstalledWidget();

			this.fillCsvFileHeadersInfo();
		});
		this.getImDomain();
	}

	getImDomain() {
		if (this.domainsService.isProductionDomain) {
			this.imDomain = this.domainsService.imProdDomainUrl;
		} else if (this.domainsService.isStagingDomain) {
			this.imDomain = this.domainsService.imStagDomainUrl;
		} else if (this.domainsService.isDevelopmentDomain) {
			this.imDomain = this.domainsService.imDevDomainUrl;
		}
	}

	setMapDotes() {
		for (const device of this.devices) {
			const deviceConfig = DeviceFactory.createDevice(device.sct_device_type).config;

			if (device.last_update_location_time) {
				this.dots.push({
					latitude: device.last_latitude,
					longitude: device.last_longitude,
					type: 'device',
					truck_id: device.truck_id,
					truck_sn: device.truck_sn,
					mac_address: device.mac_address,
					site_id: this.siteInfo.id,
					customer_id: this.siteInfo.customer_id,
					serial_number: device.serial_number,
					sct_device_type: device.sct_device_type,
					color: deviceConfig.mapColor,
					group: true,
				})
			}
		}

		const {iotahDevices, charglinkdDevices, iotahPsDevices, battlinkDevices, lithiumBattlinkDevices, battlinkIIDevices, brmDevices} = DeviceFactory.group(this.devices, {getPowerStudyDevices: true});

		this.siteInfo.iotah_devices_count = iotahDevices.length;
		this.siteInfo.chargLink_devices_count = charglinkdDevices.length;
		this.siteInfo.iotah_ps_devices_count = iotahPsDevices.length;
		this.siteInfo.battlink_devices_count = battlinkDevices.length;
		this.siteInfo.lithium_battlink_devices_count = lithiumBattlinkDevices.length;
		this.siteInfo.battlink_ii_devices_count = battlinkIIDevices.length;
		this.siteInfo.brm_devices_count = brmDevices.length;
		this.dots.push({...this.siteInfo, type: 'site'});
	}

	handleIotahUsageReportSelectDate(minInstallationDate) {
		const currentYear = moment().year();
		this.selectedYearUsageReport = currentYear;
		const minDate = moment((minInstallationDate) * 1000)
		const startYear = minDate.year();
		this.minDate = minDate.toDate();

		const yearsOption = [];
		for (let year = currentYear; year >= startYear; year--) {
			yearsOption.push(year);
		}
		this.yearsOption = yearsOption;
	}

	handleChargersUsageReportSelectDate(minInstallationDate: any) {
		const currentYear = moment().year();
		this.chargLinkSelectedYearUsageReport = currentYear;
		const minDateChargersDevices = moment((minInstallationDate) * 1000)
		const startYear = minDateChargersDevices.year();
		this.minDateChargersDevices = minDateChargersDevices.toDate();

		const chargLinkYearsOption: any = ['All Years'];
		for (let year = currentYear; year >= startYear; year--) {
			chargLinkYearsOption.push(year);
		}
		this.chargLinkYearsOption = chargLinkYearsOption;
	}

	getListQuarters(selectedYear: number, sctDeviceType = DeviceFactory.types.iotah) {
		const deviceConfig = DeviceFactory.createDevice(sctDeviceType).config;
		let minDate = deviceConfig.isCharglink ? this.minDateChargersDevices: this.minDate;

		if (+selectedYear === moment().year() || +selectedYear === moment(minDate).year()) {
			const quarters: string[] = [];
			for (let quarter = 1; quarter <= 4; quarter++) {
				if ((+selectedYear === moment().year() && quarter > moment().quarter()) || (quarter < moment(minDate).quarter() && +selectedYear === moment(minDate).year()))
					continue;
				quarters.push(`Q${quarter}`);
			}
			return quarters;
		}
		return ['Q1', 'Q2', 'Q3', 'Q4'];
	}

	getListMonths(selectedYear: number, setSelectedMonths = false) {
		const months: any[] = [{
			value: 'All-Year',
			label: this.translateService.instant('g.all_year')
		}];
		if (+selectedYear === moment().year()) {
			for (let month = 0; month <= moment().month(); month++) {
				months.push({
					value: month + 1,
					label: moment().month(month).format('MMMM')
				});
			}
			const currentMonthInList = (months.filter(month => month.label == moment().format('MMMM')))[0].value;

			this.selectedMonth = structuredClone(currentMonthInList);

			if (setSelectedMonths)
				this.chargLinkSelectedMonth = structuredClone(currentMonthInList);

			return months;
		}

		const allMonths = moment.months();
		let monthCounter = 1;
		for (const month of allMonths) {
			months.push({value: monthCounter++, label: month})
		}

		this.selectedMonth = months[1].value;

		if (setSelectedMonths)
			this.chargLinkSelectedMonth = months[1].value;

		return months;
	}

	fillChargLinkQuarterlyReportCols(fieldsAccess: any) { // to be check please
		let chargLinkQuarterCol: ColumnsConfig[] = [
			{ key: 'truck_id', name: this.translateService.instant('chargLinkDevice.devices.truck_id'), type: 'string' },
			{ key: 'truck_sn', name: this.translateService.instant('chargLinkDevice.devices.truck_sn'), type: 'link' },
			{ key: 'truck_type', name: this.translateService.instant('chargLinkDevice.devices.truck_type'), type: 'string' },
		];

		if (fieldsAccess.charger_max_power)
			chargLinkQuarterCol.push({ key: 'max_charger_kw', name: this.translateService.instant("site.charger_max_kw"), type: 'number' });

		chargLinkQuarterCol.push(
			{	key: 'total_hours', name: this.translateService.instant("site.charger_hours"), type: 'number' },

			{ key: 'total_idle_hours', name: this.translateService.instant("site.idle_hours"), type: 'number' },
			{ key: 'total_off_hours', name: this.translateService.instant("site.off_hours"), type: 'number' },

			{	key: 'total_ahr', name: this.translateService.instant("site.charger_ah"), type: 'number' },
			{	key: 'total_kwhr', name: this.translateService.instant("site.charger_kwh"), type: 'number' })

		if (fieldsAccess.truck_manufacturer)
			chargLinkQuarterCol.push({ key: "truck_manufacturer", name: this.translateService.instant("chargLinkDevice.devices.truck_manufacturer"), type: 'string' });
		this.chargLinkQuarterlyTableConfig.column = chargLinkQuarterCol;
	}

	//! will be removed until Hide Monthly Usage Data / Charts
	// fillQuarterlyReportCols(fieldsAccess: any) {
	// 	let column: ColumnsConfig[] = [];
	// 	column = [
	// 		{ key: 'truck_sn', name: this.translateService.instant('devices.truck_sn'), type: 'link' },
	// 		{ key: 'truck_id', name: this.translateService.instant('devices.truck_id'), type: 'string' },
	// 		{ key: 'truck_type', name: this.translateService.instant('devices.truck_type'), type: 'string' },
	// 		{ key: 'total_hours', name: this.translateService.instant('site.total_hours'), type: 'number' },
	// 		{ key: 'total_ahr', name: this.translateService.instant('site.total_ahr'), type: 'number' },
	// 		{ key: 'total_kwhr', name: this.translateService.instant('site.total_kwhr'), type: 'number' },
	// 		{ key: 'truck_year', name: this.translateService.instant('site.new_old'), type: 'boolean', hidden: true, filterFalseText: this.translateService.instant('g.old'), filterTrueText: this.translateService.instant('g.new') }
	// 	];

	// 	if (fieldsAccess.truck_manufacturer)
	// 		column.push({ key: 'truck_manufacturer', name: this.translateService.instant("devices.truck_manufacturer"), type: 'string' });

	// 	column.push({ key: "truck_manufacturing_year", name: this.translateService.instant("devices.truck_manufacturing_year"), type: 'date' });

	// 	if (fieldsAccess.last_pm_date)
	// 		column.push({ key: "last_pm_date", name: this.translateService.instant("site.last_pm_date"), type: 'date' });

	// 	if (fieldsAccess.billed_kwhr)
	// 		column.push({ key: "billed_kwhr", name: this.translateService.instant("site.billed_kwhr"), type: 'number' });

	// 	this.truckUsageReportTableConfig.column = column;
	// }

	prepareDevicesGridCols() {
		let devicesGridCols: ColumnsConfig[] = [
			{ key: "serial_number", name: this.translateService.instant("g.iotah_sn"), type: 'string' },
		];

		if (this.usersService.hasAccessPermission({ permission: this.permissions }, 'noc'))
			devicesGridCols.push({ key: "fw_version", name: this.translateService.instant("devices.fw_version"), type: 'number' });

		devicesGridCols.push(
			{ key: 'truck_sn', name: this.translateService.instant('devices.truck_sn'), type: 'link'}
		);

		if (this.usersService.hasAccessPermission({ permission: this.permissions }, 'basic_setup')) {
			devicesGridCols.push(
				{ key: 'truck_id', name: this.translateService.instant('devices.truck_id'), type: 'link'},
			);
		}

		devicesGridCols.push(
			{ key: 'truck_manufacturer', name: this.translateService.instant('devices.truck_manufacturer'), type: 'string' },
			{ key: "truck_type", name: this.translateService.instant("devices.truck_type"), type: 'string', hidden: true },
			{ key: "mac_address", name: this.translateService.instant("devices.unique_mac_address"), type: 'string', hidden: true },
			{ key: "hw_version", name: this.translateService.instant("devices.hw_version"), type: 'string', hidden: true },
			{ key: "ip_address", name: this.translateService.instant("g.ip_address"), type: 'string' },
			{ key: "_voltage", name: this.translateService.instant("rt.voltage"), type: 'number' },
			{ key: "battery_capacity", name: this.translateService.instant("devices.battery_capacity"), type: 'number' },
			{ key: "_installation_date_ms", name: this.translateService.instant("devices.installation_date"), type: 'timestamp', dateFormat: 'MM/DD/YYYY' },
			{ key: "last_connect_time_formatted", name: this.translateService.instant("devices.last_connect_time"), type: 'date_with_ref' },
			{ key: 'last_connected_in', name: this.translateService.instant('devices.last_connected_in'), type: "string" },
		);

		if (this.usersService.hasAccessPermission({ permission: this.permissions }, 'noc')) {
			devicesGridCols.push(
				{ key: "connectivity_verfication_status_formatted", name: this.translateService.instant("connectivity_verification.connectivity_verification_status"), type: 'link' },
				{ key: "shipment_quality_result_formatted", name: this.translateService.instant("devices.shipment_quality_checked"), type: 'link' },
			);
		}

		let filteredCols = [];
		if (this.IoTAhDevices.length > 0) {
			devicesGridCols.forEach((col) => {
				if ((col.key in this.devices[0])) {
					filteredCols.push(col);
				}
			});
		}

		this.common.applyTimeSourceTooltips(filteredCols, this.timeSourceByColumn);
		this.installedIotahDeviceTableConfig.column = filteredCols;
	}

	prepareChargeLinkDevicesGridCols(fieldsAccess) {
		let devicesGridCols: ColumnsConfig[] = [
			{ key: "serial_number", name: this.translateService.instant("chargLinkDevice.g.iotah_sn"), type: 'string' },
		];

		if (this.usersService.hasAccessPermission({ permission: this.permissions }, 'noc'))
			devicesGridCols.push({ key: "fw_version", name: this.translateService.instant("devices.fw_version"), type: 'number' });

		devicesGridCols.push(
			{ key: 'truck_sn', name: this.translateService.instant('chargLinkDevice.devices.truck_sn'), type: 'link'},
		);

		if (this.usersService.hasAccessPermission({ permission: this.permissions }, 'basic_setup')) {
			devicesGridCols.push(
				{ key: 'truck_id', name: this.translateService.instant('chargLinkDevice.devices.truck_id'), type: 'link'},
				{ key: 'truck_manufacturer', name: this.translateService.instant('devices.charger_manufacturer'), type: 'string' },
			);
		}

		devicesGridCols.push(
			{ key: "truck_type", name: this.translateService.instant("chargLinkDevice.devices.truck_type"), type: 'string', hidden: true },
		);

		if (fieldsAccess.charger_max_power)
			devicesGridCols.push({ key: 'max_charger_kw', name: this.translateService.instant("chargLinkDevice.devices.charger_max_power"), type: 'number', noValueString: '-'})

		devicesGridCols.push(
			{ key: "mac_address", name: this.translateService.instant("devices.unique_mac_address"), type: 'string', hidden: true },
			{ key: "hw_version", name: this.translateService.instant("devices.hw_version"), type: 'string', hidden: true },
			{ key: "ip_address", name: this.translateService.instant("g.ip_address"), type: 'string' },
			{ key: "_voltage", name: this.translateService.instant("rt.voltage"), type: 'number', noValueString: '-'},
			{ key: "_installation_date_ms", name: this.translateService.instant("devices.installation_date"), type: 'timestamp', dateFormat: 'MM/DD/YYYY' },
			{ key: "last_connect_time_formatted", name: this.translateService.instant("devices.last_connect_time"), type: 'date_with_ref' },
			{ key: 'last_connected_in', name: this.translateService.instant('devices.last_connected_in'), type: "string" },
		);

		if (this.usersService.hasAccessPermission({ permission: this.permissions }, 'noc')) {
			devicesGridCols.push(
				{ key: "connectivity_verfication_status_formatted", name: this.translateService.instant("connectivity_verification.connectivity_verification_status"), type: 'link' },
				{ key: "shipment_quality_result_formatted", name: this.translateService.instant("devices.shipment_quality_checked"), type: 'link' },
			);
		}

		let filteredCols = [];
		if (this.chargeLinkDevices.length > 0) {
			devicesGridCols.forEach((col) => {
				if ((col.key in this.devices[0])) {
					filteredCols.push(col);
				}
			});
		}

		this.common.applyTimeSourceTooltips(filteredCols, this.timeSourceByColumn);
		this.installedChargerDeviceTableConfig.column = filteredCols;
	}

	ngOnDestroy() {
		this.permissionsSub.unsubscribe();
	}

	formatDeviceFields(devices, permission) {
		devices.forEach((device, idx) => {
			device = this.common.decompress(device, 'siteDevice');
			devices[idx] = device;
			if (this.usersService.hasAccessPermission({ permission }, 'number_of_cells')) {
				let deviceVPC = (device.vpc !== undefined) ? device.vpc : ((this.deviceService.getBatteryType(device) == this.deviceService.batteryTypesByName.lithuim_ion) ? 3 : 2);
				const voltage = (device.number_of_cells * deviceVPC);
				device._voltage = voltage;
			}
			if (this.usersService.hasAccessPermission({ permission }, 'installation_date'))
				device._installation_date_ms = device.installation_date * 1000;

			device.fw_version = this.common.toFixedWithoutRounding(device.fw_version, this.usersService.getCurrentUser().is_admin ? 4 : 2);
			device.last_connect_time_formatted = device.last_connect_time ? moment(device.last_connect_time * 1000).format('MM/DD/YYYY HH:mm:ss') : '--/--/--';
			device.connectivity_verfication_status_formatted = this.translateService.instant(`g.${this.getStatus(device, 'connectivity_verfication_result')}`);
			device.shipment_quality_result_formatted = this.translateService.instant(`g.${this.getStatus(device, 'shipment_quality_result')}`);
			device.last_connected_in = device.last_connect_time ? this.common.getLastConnectedIn(device.last_connect_time) : '-';

			/** handle Battery remaining life years and ah */
			const deviceConfig = DeviceFactory.createDevice(device.sct_device_type).config;
			if (deviceConfig.isBattlink) {
				const {percentLifeRemainingYears, percentLifeRemainingAh} = this.deviceService.getBatteryRemainingLifeData(device);
				device.battery_life_remainig_yrs = percentLifeRemainingYears ? percentLifeRemainingYears?.toFixed(2) : 0;
				device.battery_life_remaining_ah = percentLifeRemainingAh ? percentLifeRemainingAh?.toFixed(2) : 0;
			}
		});
		return devices;
	}

	getStatus (device, field) {
		const shipmentResults = {
			notTested: 0,
			passed: 1,
			failed: 2
		}

		let res = 'not_tested';
		if (device[field] && device[field].report_id){
			if (device[field]?.result == shipmentResults.passed) {
				res = `passed`;
				if (device[field]?.skip_cellular_check)
					res = `passed_without_checking_cellular`;
			}

			if (device[field]?.result == shipmentResults.failed)
				res = `failed`;
		}

		return res;
	}

	setInfoBoxSiteAnalyticsData() {
		const selectedData = this.infoBox[this.selectedDataOption];
		const chargLinkDevices = selectedData?.chargLink_devices;

		if (selectedData && chargLinkDevices) {
			chargLinkDevices.hours = chargLinkDevices.charge_hours;
			chargLinkDevices.ahrs = chargLinkDevices.charge_ahrs;
			delete chargLinkDevices.charge_hours;
			delete chargLinkDevices.charge_ahrs;
		}

		this.infoBoxSiteAnalytics = selectedData;
	}

	showOnlyConnectedIPs(flag) {
		let ips = [];
		let data = this.devices;

		if (data.length == 0) {
			this.uniqueIPaddresses = [];
			return;
		}

		if (flag) {
			let frequency = 900;
			let nowDate = Math.round(new Date().getTime() / 1000);
			data.forEach(device => {
				let disconnectTime = nowDate - device.last_connect_time; //disconnectTime in seconds
				if (device.ip_address && disconnectTime <= (2.5 * frequency)) {
					ips.push(device.ip_address);
				}
			});

		} else {
			data.forEach(device => {
				if (device.ip_address) {
					ips.push(device.ip_address);
				}
			});
		}

		ips = ips.filter(function (elem, pos) {
			return ips.indexOf(elem) == pos;
		});
		this.uniqueIPaddresses = ips;
	}

	prepareQuarterReport(data, deviceType: number) {
		const deviceConfig = DeviceFactory.createDevice(deviceType).config;
		const analyticsType = deviceConfig.reporting.device;

		const qData = data[analyticsType];
		const periods = _.sortBy(Object.keys(qData)).reverse();

		if (periods.length) {
			if (deviceConfig.isCharglink) {
				this.chargLinkQuarterData = qData;
				this.chargLinkSelectedYear = periods[0];
				this.chargLinkSelectedQuarter = Object.keys(qData[this.chargLinkSelectedYear].quarters)[0];
				this.chargLinkQuartersOption = this.getListQuarters(this.chargLinkSelectedYear, DeviceFactory.types.charglink);
				this.chargLinkMonthsOption = this.getListMonths(this.chargLinkSelectedYear, true).filter(month => month.value != 'All-Year');
			} else {
				this.monthData = qData;
				this.selectedYearQ = periods[0];
				this.selectedMonth = +Object.keys(qData[this.selectedYearQ].months)[0];
				this.monthsOption = this.getListMonths(this.selectedYearQ);
			}
			this.loadQuarterData(deviceType);
		}
	}

	loadQuarterData(deviceType: number, updateMonthsList = false) {
		const deviceConfig = DeviceFactory.createDevice(deviceType).config;

		if (deviceConfig.isCharglink) {
			let chargLinkQuarterDataFormatted = [];
			this.charglinkSelectedQuarterData = [];

			this.chargLinkSelectedYearUsageReport = this.chargLinkSelectedYear;


			if (this.chargLinkSelectedYear == 'All Years') {
				const allYearsData: any = {};

				if (Object.keys(this.chargLinkQuarterData).length) {
					for (const year in this.chargLinkQuarterData) {
						const qData = this.chargLinkQuarterData[year];

						if (qData) {
							const yearData = qData['All-Year'];

							for (const deviceData of yearData) {
								const macAddress = deviceData.mac_address;

								if (!allYearsData[macAddress]) {
									allYearsData[macAddress] = { ...deviceData };
								} else {
									allYearsData[macAddress].total_events_time += deviceData.total_events_time;
									allYearsData[macAddress].total_events_ahr += deviceData.total_events_ahr;
									allYearsData[macAddress].total_kwhr += deviceData.total_kwhr;

									allYearsData[macAddress].total_hours = deviceData.total_events_time;

									allYearsData[macAddress].total_idle_events_time ||= 0;
									allYearsData[macAddress].total_off_events_time ||= 0;

									allYearsData[macAddress].total_idle_events_time += (deviceData.total_idle_events_time || 0);
									allYearsData[macAddress].total_off_events_time += (deviceData.total_off_events_time || 0);

									allYearsData[macAddress].total_ahr = allYearsData[macAddress].total_events_ahr;
								}
							}
						}
					}
				}

				if (Object.keys(allYearsData).length)
					chargLinkQuarterDataFormatted = Object.values(allYearsData);
			} else {
				const qData = this.chargLinkQuarterData[this.chargLinkSelectedYear];
				if (qData) {
					switch (this.chargeLinkSelectedPeriodType) {
						case this.periodTypes.all_year:
							if (qData['All-Year'])
								chargLinkQuarterDataFormatted = qData['All-Year'];
							break;
						case this.periodTypes.quarter:
							if (qData.quarters && qData.quarters[this.chargLinkSelectedQuarter])
								chargLinkQuarterDataFormatted = qData.quarters[this.chargLinkSelectedQuarter];
							break;
						case this.periodTypes.month:
							if (qData.months && qData.months[this.chargLinkSelectedMonth])
								chargLinkQuarterDataFormatted = qData.months[this.chargLinkSelectedMonth];
							break;
						default:
							break;
					}
				}
			}

			const charglinkSelectedQuarterData = [];

			[...chargLinkQuarterDataFormatted].forEach((row) => {
				let rowData: TableData = {
					truck_sn: { value: row.truck_sn, link: ['/', this.siteInfo.customer_id, this.siteInfo.id, row.mac_address, "performance"]},
					truck_id: { value: row.truck_id},
					truck_type: { value: row.truck_type},
					max_charger_kw: { value: +(row.max_charger_kw || 0).toFixed(2)},
					total_hours: { value: row.total_events_time },

					total_idle_hours: { value: row.total_idle_events_time },
					total_off_hours: { value: row.total_off_events_time },

					total_ahr: { value: Math.round(row.total_events_ahr || 0).toLocaleString()},
					total_kwhr: { value: Math.round(row.total_kwhr || 0).toLocaleString()},
					truck_manufacturer: { value: row.truck_manufacturer},
				}
				charglinkSelectedQuarterData.push(rowData);
			});

			this.charglinkSelectedQuarterData = charglinkSelectedQuarterData;

			this.chargLinkQuarterlyTableConfig.data = this.charglinkSelectedQuarterData;
		} else {
			//! will be removed until Hide Monthly Usage Data / Charts
			// if (updateMonthsList) {
			// 	this.selectedMonth = +Object.keys(this.monthData[this.selectedYearQ].months)[0];
			// 	this.monthsOption = this.getListMonths(this.selectedYearQ);
			// }

			// const selectedMonthUsageData = [];
			// this.selectedYearUsageReport = this.selectedYearQ;
			// //this.selectedQuarter--;
			// this.selectedMonthData = this.monthData[this.selectedYearQ] ? this.monthData[this.selectedYearQ].months[this.selectedMonth] ?? [] : [];
			// if (this.selectedTruckYear == 'new') {
			// 	this.selectedMonthData = _.filter(this.selectedMonthData, (device) => { return this.deviceService.isNewDevice(device.truck_manufacturing_year); });
			// } else if (this.selectedTruckYear == 'old') {
			// 	this.selectedMonthData = _.filter(this.selectedMonthData, (device) => { return !this.deviceService.isNewDevice(device.truck_manufacturing_year); });
			// }

			// [...this.selectedMonthData].forEach((row) => {
			// 	let rowData: TableData = {
			// 		row,
			// 		truck_sn: { value: row.truck_sn, link: ["/", this.siteInfo.customer_id, this.siteInfo.id, row.mac_address, "performance"] },
			// 		truck_id: { value: row.truck_id },
			// 		truck_type: { value: row.truck_type },
			// 		total_hours: { value: row.total_hours },
			// 		total_ahr: { value: +(row.total_ahr || 0).toFixed(2) },
			// 		total_kwhr: { value: +(row.total_kwhr || 0).toFixed(2) },
			// 		truck_year: { value: row.truck_year, trueText: this.translateService.instant('g.new'), falseText: this.translateService.instant('g.old') },
			// 		truck_manufacturer: { value: row.truck_manufacturer },
			// 		truck_manufacturing_year: { value: row.truck_manufacturing_year },
			// 		last_pm_date: { value: row.last_pm_date },
			// 		billed_kwhr: { value: +(row.billed_kwhr || 0).toFixed(2) }
			// 	}
			// 	selectedMonthUsageData.push(rowData);
			// });

			// this.truckUsageReportTableConfig.data = selectedMonthUsageData;
		}
	}

	prepareTags(tagsData) {
		this.tags = [];
		Object.values(tagsData.siteTags).forEach((tag) => {
			this.tags.push(this.common.decompress(tag, 'tag'));
		});
		this.deviceTags = tagsData.deviceTags;
	}

	//! will be removed until Hide Monthly Usage Data / Charts
	// exportMonthlyData(allMonths?: boolean) {
	// 	let name = 'Monthly';
	// 	let data = this.monthData || [];
	// 	if (!allMonths) {
	// 		data = { [this.selectedMonth]: this.selectedMonthData };
	// 		name = moment(this.selectedMonth, 'MM').format('MMMM');
	// 	}

	// 	if (allMonths && data) {
	// 		data = data[this.selectedYearQ];
	// 		delete data['All-Year'];
	// 	}
	// 	this.common.exportMonthsData(this.truckUsageReportTableConfig.column, data, `${name}_${this.siteInfo.name}_report`, false);
	// }

	exportChargeLinkQuarterData(allQuraters?: boolean) {
		let name = 'quarterly';
		let data = this.chargLinkQuarterData;
		if (!allQuraters) {
			data = { [this.chargLinkSelectedQuarter]: this.charglinkSelectedQuarterData };
			name = this.chargLinkSelectedQuarter;
			data[name] = this.getValues(data[name]);
		}

		if (allQuraters) {
			const filteredData = {};
			for (const key1 in data) {
				if (data.hasOwnProperty(key1)) {
					for (const key2 in data[key1]) {
						const filteredArray = data[key1][key2];
						if (filteredArray.length > 0) {
							filteredData[`${key1}_${key2}`] = filteredArray;
						}
					}
				}
			}
			data = filteredData;
		}

		this.common.exportQuartersData(this.chargLinkQuarterlyTableConfig.column, data, `${name}_${this.siteInfo.name}_report`);
	}

	getValues(data) {
		const returnData = [];

		for (const row of data) {
			const returnObj = {};

			for (const key in row) {
				returnObj[key] = row[key].value;
			}

			returnData.push(returnObj);
		}

		return returnData;
	}

	filterDevices() {
		const {
			 	iotahDevices,
				charglinkdDevices,
				battlinkDevices,
				brmDevices,
				ioTEmeterSp1,
				ioTEmeterSp3,
				ioTEmeter,
				ioTEmeterEdge,
				lithiumBattlinkDevices,
				battlinkIIDevices
			} = DeviceFactory.group(this.devices);

		this.chargeLinkDevices = charglinkdDevices.concat(brmDevices);
		this.IoTAhDevices = iotahDevices;
		this.battlinkDevices = battlinkDevices;

		this.meteredDevices = [...ioTEmeterSp1, ...ioTEmeterSp3, ...ioTEmeter, ...ioTEmeterEdge];
		this.allBattlinkDevices = [...battlinkDevices, ...lithiumBattlinkDevices, ...battlinkIIDevices];
		if (this.allBattlinkDevices.length)
			this.getBatteriesVoltageCapacityInfo(this.allBattlinkDevices);

		const filteredIotahDevices = [];
		const filteredCharglinkDevices = [];

		if (this.IoTAhDevices.length) {
			for (const device of this.IoTAhDevices) {
				const exists = this.truckTypeList.some(t => t.value == device.truck_type);
				if (!exists)
					this.truckTypeList.push({value: device.truck_type, label: device.truck_type});
			}
		}

		[...this.IoTAhDevices].forEach((row) => {
			let rowData: TableData = {
				serial_number: { value: row.serial_number },
				fw_version: { value: row.fw_version },
				truck_sn: { value: row.truck_sn, link: row.truck_sn ? ['/', this.siteInfo.customer_id, this.siteInfo.id, row.mac_address, 'performance'] : null },
				truck_id: { value: row.truck_id },
				truck_manufacturer: {value: row.truck_manufacturer },
				truck_type: { value: row.truck_type },
				mac_address: { value: row.mac_address },
				hw_version: { value: row.hw_version },
				ip_address: { value: row.ip_address },
				_voltage: { value: row._voltage },
				battery_capacity: { value: row.battery_capacity },
				_installation_date_ms: { value: row._installation_date_ms },
				last_connect_time_formatted: { value: row.last_connect_time_formatted },
				last_connected_in: {value: row.last_connected_in, sortValue: moment().utc().unix() - +row.last_connect_time },
				connectivity_verfication_status_formatted: { value: row.connectivity_verfication_status_formatted, link: row.connectivity_verfication_result && row.connectivity_verfication_result.report_id? ['/', 'admin-panel', 'connectivity-verification-log', row.connectivity_verfication_result?.report_id] : null},
				shipment_quality_result_formatted: { value: row.shipment_quality_result_formatted, link: row.shipment_quality_result && row.shipment_quality_result.report_id? ['/', 'management', 'shipment-quality-history', row.shipment_quality_result?.report_id] : null}
			}
			filteredIotahDevices.push(rowData);
		});

		this.installedIotahDeviceTableConfig.data = filteredIotahDevices;

		[...this.chargeLinkDevices].forEach((row) => {
			let rowData: TableData = {
				serial_number: { value: row.serial_number },
				fw_version: { value: row.fw_version },
				truck_sn: { value: row.truck_sn, link: row.truck_sn ? ['/', this.siteInfo.customer_id, this.siteInfo.id, row.mac_address, 'performance'] : null },
				truck_id: { value: row.truck_id},
				truck_manufacturer: { value: row.truck_manufacturer },
				truck_type: { value: row.truck_type },
				max_charger_kw: { value: row.max_charger_kw },
				mac_address: { value: row.mac_address },
				hw_version: { value: row.hw_version },
				ip_address: { value: row.ip_address },
				_voltage: { value: this.deviceCommonService.getChargerVoltageLabel(row.charger_voltage), sortValue: row.charger_voltage },
				_installation_date_ms: { value: row._installation_date_ms },
				last_connect_time_formatted: { value: row.last_connect_time_formatted },
				last_connected_in: {value: row.last_connected_in, sortValue: moment().utc().unix() - +row.last_connect_time },
				connectivity_verfication_status_formatted: { value: row.connectivity_verfication_status_formatted, link: row.connectivity_verfication_result && row.connectivity_verfication_result.report_id? ['/', 'admin-panel', 'connectivity-verification-log', row.connectivity_verfication_result?.report_id] : null},
				shipment_quality_result_formatted: { value: row.shipment_quality_result_formatted, link: row.shipment_quality_result && row.shipment_quality_result.report_id? ['/', 'management', 'shipment-quality-history', row.shipment_quality_result?.report_id] : null}
			}
			filteredCharglinkDevices.push(rowData);
		});

		this.installedChargerDeviceTableConfig.data = filteredCharglinkDevices;
	}

	getBatteriesVoltageCapacityInfo(devicesInfo) {
		const batteriesCapacityInfo = _.uniq(devicesInfo.map(device => device.battery_capacity)).map(capacity => ({ value: capacity, label: capacity }));
		if (batteriesCapacityInfo.length)
			this.batterySummaryCapacityOptions = this.batterySummaryCapacityOptions.concat(batteriesCapacityInfo)

		const batteriesVoltageInfo = _.uniq(devicesInfo.map(device => device._voltage)).map(voltage => ({ value: voltage, label: voltage }));
		if (batteriesVoltageInfo.length)
			this.batterySummaryVoltageOptions = this.batterySummaryVoltageOptions.concat(batteriesVoltageInfo);

		this.selectedBatterySummaryVoltageFilter = this.batterySummaryVoltageOptions[0].value;
		this.selectedBatterySummaryCapacityFilter = this.batterySummaryCapacityOptions[0].value;
	}

	formatQuarterReportData(period) {
		const device = this.common.decompress(period.device, 'siteDevice');
		const qData = this.common.decompress(period.data, 'devicePerformance');
		if (device.last_pm_date && device.last_pm_date > 0)
			this.deviceService.formatDeviceFields(device);

		let quarterObj: any = {}
		quarterObj.mac_address = device.mac_address;
		quarterObj.truck_type = device.truck_type;
		quarterObj.truck_sn = device.truck_sn;
		quarterObj.truck_id = device.truck_id;
		quarterObj.truck_manufacturing_year = device.truck_manufacturing_year;

		quarterObj.total_hours = Math.round(qData.accurate_inuse_time / 3600);
		quarterObj.total_ahr = (qData.total_inuse_as_from_all_events / 3600);
		quarterObj.total_kwhr = (qData.total_inuse_ws_from_all_events / 1000 / 3600);

		quarterObj.truck_year = this.translateService.instant(this.deviceService.isNewDevice(device.truck_manufacturing_year) ? 'g.new' : 'g.old');
		quarterObj.truck_manufacturer = device.truck_manufacturer;
		quarterObj.last_pm_date = device.last_pm_date_fmt || 'N/A';
		quarterObj.billed_kwhr = this.deviceService.calculateBilledKWHr(quarterObj.total_kwhr, device);

		return quarterObj;
	}

	getChargersDevices(devices: any[]) {
		this.chargersDevices = devices.filter((device) => {
			return [DeviceFactory.types.charglink, DeviceFactory.types.brm].includes(device.sct_device_type);
		});
	}

	fillChargerInventoryReportTableConfig() {
		if (!this.chargersDevices.length)
			return;

		this.chargerInventoryReportTableConfig.column = [
			{ key: 'truck_id', name: this.translateService.instant('chargLinkDevice.devices.truck_id'), type: 'string' },
			{ key: 'truck_sn', name: this.translateService.instant('devices.charger_serial_number'), type: 'link' },
			{ key: 'truck_manufacturer', name: this.translateService.instant('chargLinkDevice.devices.truck_manufacturer'), type: 'string' },
			{ key: 'truck_manufacturer_date', name: this.translateService.instant('chargLinkDevice.devices.truck_manufacturer_date'), type: 'string' },
			{ key: 'truck_type', name: this.translateService.instant('chargLinkDevice.devices.truck_type'), type: 'string' },
			{ key: "last_pm_date", name: this.translateService.instant("site.last_pm_date"), type: 'timestamp', dateFormat: 'MM/DD/YYYY' },
		];

		const tableData = [];
		this.chargersDevices.forEach((device: any) => {
			tableData.push({
				truck_id: { value: device.truck_id },
				truck_sn: { value: device.truck_sn, link: ['/', this.siteInfo.customer_id, this.siteInfo.id, device.mac_address, 'performance'] },
				truck_manufacturer: { value: device.truck_manufacturer },
				truck_manufacturer_date: { value: device.truck_manufacturing_month + '/' + device.truck_manufacturing_year },
				truck_type: { value: device.truck_type },
				last_pm_date: { value: device.last_pm_date*1000 }
			});
		});

		this.chargerInventoryReportTableConfig.data = tableData;
	}

	chargerUsageReportUpdateSelectedYear() {
		const reportData = this.siteDevicesAnalytics.usageData.qReport.chargLink;

		// Update selected quarter
		if (reportData[this.chargLinkSelectedYear]?.quarters) {
			const quarters = Object.keys(reportData[this.chargLinkSelectedYear].quarters);
			if (!quarters.includes(this.chargLinkSelectedQuarter))
				this.chargLinkSelectedQuarter = quarters[0];
		}

		// Update Quarters and Months Options
		this.chargLinkQuartersOption = this.getListQuarters(this.chargLinkSelectedYear, this.deviceFactory.types.charglink);
		this.chargLinkMonthsOption = this.getListMonths(this.chargLinkSelectedYear).filter(month => month.value != 'All-Year');

		if (!this.chargLinkSelectedMonth) {
			const currentMonthInList = (this.chargLinkMonthsOption.filter(month => month.label == moment().format('MMMM')))[0].value;
			this.chargLinkSelectedMonth = currentMonthInList;
		}

		if(!this.chargLinkMonthsOption.find(item => item.value == this.chargLinkSelectedMonth))
			this.chargLinkSelectedMonth = this.chargLinkMonthsOption[this.chargLinkMonthsOption.length-1].value;

		this.loadQuarterData(this.deviceFactory.types.charglink);
	}

	chargerUsageReportUpdateSelectedPeriodType() {
		const reportData = this.siteDevicesAnalytics.usageData.qReport.chargLink;

		switch (this.chargeLinkSelectedPeriodType) {
			case this.periodTypes.quarter:
				// Update selected quarter
				this.chargLinkSelectedQuarter = Object.keys(reportData[this.chargLinkSelectedYear].quarters)[0];
				break;
			case this.periodTypes.month:
				// Update Months Options
				this.chargLinkMonthsOption = this.getListMonths(this.chargLinkSelectedYear).filter(month => month.value != 'All-Year');
				break;
		}

		this.loadQuarterData(this.deviceFactory.types.charglink);
	}

	getSiteDevicesAnalyticsData() {
		this.sitesService.getSiteDevicesAnalyticsData(this.siteId).subscribe((res: any) => {
			this.siteDevicesAnalyticsData = this.formatDevicesAnalyticsData(res);
			this.prepareSummaryTruckUsageReport();
			this.prepareBatterySummaryReport();
		});
	}

	formatDevicesAnalyticsData(data) {
		const analyticsKeys = [
			'last_week',
			'last_7_days',
			'last_30_days',
			'last_month',
			'last_90_days',
			'year_to_date',
			'last_year',
			'since_installation',
		];
		const finalResult = {};
		for (let deviceData of data) {
			deviceData.quarters = {};
			for (const quarter in deviceData.quarters_data) {
				deviceData.quarters[quarter] = this.common.decompress(deviceData.quarters_data[quarter], 'devicePerformance');
			}
			delete deviceData.quarters_data;

			for(const key of analyticsKeys) {
				deviceData[key] = this.common.decompress(deviceData[key], 'devicePerformance');
			}

			finalResult[deviceData.mac_address] = deviceData;
		}

		return finalResult;
	}

	onSelectionChanged(event: string) {
		this.selectedTimePeriodFilters = event;
	}

	// Truck Inventory Report
	prepareTruckInventoryReportColumns() {
		let devicesGridCols: ColumnsConfig[] = [
			{ key: 'truck_id', name: this.translateService.instant('devices.truck_id'), type: 'link'},
			{ key: 'truck_sn', name: this.translateService.instant('devices.truck_sn'), type: 'link'},
			{ key: "truck_type", name: this.translateService.instant("devices.truck_type"), type: 'string' },
			{ key: 'truck_manufacturer', name: this.translateService.instant("devices.truck_manufacturer"), type: 'string' },
			{ key: "truck_manufacturing_year", name: this.translateService.instant("devices.truck_manufacturing_year"), type: 'string' },
			{ key: "last_longitude", name: this.translateService.instant("devices.last_truck_longitude"), type: 'string' },
			{ key: "last_latitude", name: this.translateService.instant("devices.last_truck_latitude"), type: 'string' },
			{ key: "last_pm_date", name: this.translateService.instant("site.last_pm_date"), type: 'timestamp', dateFormat: 'MM/DD/YYYY' },
		];

		this.common.applyTimeSourceTooltips(devicesGridCols, this.timeSourceByColumn);
		this.truckInventoryReport.column = devicesGridCols;

		const filteredTruckInventoryReportData = [];
		[...this.IoTAhDevices].forEach((row) => {
			let rowData: TableData = {
				row,
				truck_id: { value: row.truck_id },
				truck_sn: { value: row.truck_sn, link: row.truck_sn ? ["/", this.siteInfo.customer_id, this.siteInfo.id, row.mac_address, "performance"] : null },
				truck_type: { value: row.truck_type },
				truck_manufacturer: { value: row.truck_manufacturer },
				truck_manufacturing_year: { value: row.truck_manufacturing_year },
				last_longitude: { value: row.last_longitude },
				last_latitude: { value: row.last_latitude },
				last_pm_date: { value: row.last_pm_date*1000 },
			}
			filteredTruckInventoryReportData.push(rowData);
		});

		this.truckInventoryReport.data = filteredTruckInventoryReportData;
	}

	prepareSummaryTruckUsageReport() {
		const tableData = [];
		this.summaryTruckUsageReport.data = [];

		if (!this.IoTAhDevices.length)
			return;

		let filteredDevices = this.IoTAhDevices;
		if (this.selectedSummaryTruckTypeFilter != 'all')
			filteredDevices = this.IoTAhDevices.filter((device) => device.truck_type == this.selectedSummaryTruckTypeFilter);

		for(const device of filteredDevices) {
			let siteDevicesAnalytics = this.siteDevicesAnalyticsData[device.mac_address] || {};
			siteDevicesAnalytics = siteDevicesAnalytics[this.selectedSummaryTruckUsageFilter] || {};
			tableData.push({
				truck_id: { value: device.truck_id },
				truck_sn: { value: device.truck_sn, link: device.truck_sn ? ['/', this.siteInfo.customer_id, this.siteInfo.id, device.mac_address, 'performance'] : null },
				truck_type: { value: device.truck_type },
				drive_hours: { value:  +(siteDevicesAnalytics?.total_travel_time/3600 || 0).toFixed(2) },
				lift_hours: { value:  +(siteDevicesAnalytics?.total_lift_time/3600 || 0).toFixed(2)  },
				deadman_hours: { value:  +(siteDevicesAnalytics?.accurate_inuse_time/3600 || 0).toFixed(2)},
				idle_hours: { value: +(siteDevicesAnalytics?.idle_time/3600 || 0).toFixed(2) },
				off_charge_hours: { value: +(siteDevicesAnalytics?.total_off_time/3600 || 0).toFixed(2)},
				inuse_ah: { value: Math.round(+siteDevicesAnalytics?.total_inuse_as_from_all_events/3600 || 0).toLocaleString()},
				inuse_kwh: { value: Math.round(+siteDevicesAnalytics?.total_billed_ws / 1000 / 3600 || 0).toLocaleString()},
			});
		}

		this.summaryTruckUsageReport.data = tableData;
	}

	changeSummaryTruckReportTypeFilter(value) {
		this.selectedSummaryTruckTypeFilter = value;
		this.prepareSummaryTruckUsageReport();
	}

	changeSummaryReportDurationFilter(value) {
		this.selectedSummaryTruckUsageFilter = value;
		this.prepareSummaryTruckUsageReport();
	}

	prepareInstalledBatteryReport() {
		let devicesGridCols: ColumnsConfig[] = [
			{ key: "serial_number", name: this.translateService.instant("battlinkDevice.g.iotah_sn"), type: 'string' },
			{ key: "fw_version", name: this.translateService.instant("devices.fw_version"), type: 'number' },
			{ key: 'truck_id', name: this.translateService.instant('battlinkDevice.devices.truck_id'), type: 'string'},
			{ key: 'truck_manufacturer', name: this.translateService.instant('battlinkDevice.devices.truck_manufacturer'), type: 'string' },
			{ key: 'truck_sn', name: this.translateService.instant('battlinkDevice.smart_rebates_reports.truck_sn'), type: 'link'},
			{ key: "_voltage", name: this.translateService.instant("battlinkDevice.devices.battery_voltage"), type: 'number' },
			{ key: "battery_capacity", name: this.translateService.instant("devices.battery_capacity"), type: 'number' },
			{ key: "_installation_date_ms", name: this.translateService.instant("devices.installation_date"), type: 'timestamp', dateFormat: 'MM/DD/YYYY' },
			{ key: "last_connect_time_formatted", name: this.translateService.instant("devices.last_connect_time"), type: 'date_with_ref' },
			{ key: 'last_connected_in', name: this.translateService.instant('devices.last_connected_in'), type: "string" },
			{ key: "last_longitude", name: this.translateService.instant("battlinkDevice.devices.last_battery_long"), type: 'number' },
			{ key: "last_latitude", name: this.translateService.instant("battlinkDevice.devices.last_battery_lat"), type: 'number' },
		];

		if (this.usersService.hasAccessPermission({ permission: this.permissions }, 'noc')) {
			devicesGridCols.push(
				{ key: "connectivity_verfication_status_formatted", name: this.translateService.instant("connectivity_verification.connectivity_verification_status"), type: 'link' },
				{ key: "shipment_quality_result_formatted", name: this.translateService.instant("devices.shipment_quality_checked"), type: 'link' },
			);
		}

		let filteredCols = [];
		if (this.allBattlinkDevices.length > 0) {
			devicesGridCols.forEach((col) => {
				if ((col.key in this.devices[0]))
					filteredCols.push(col);
			});
		}

		this.common.applyTimeSourceTooltips(filteredCols, this.timeSourceByColumn);
		this.installedBattlinkDevicesReportsConfig.column = filteredCols;

		let filteredBattlinkDevices = [];
		[...this.allBattlinkDevices].forEach((row) => {
			let rowData: TableData = {
				serial_number: {value: row.serial_number },
				fw_version: {value: row.fw_version },
				truck_id: {value: row.truck_id},
				truck_manufacturer: {value: row.truck_manufacturer},
				truck_sn: {value: row.truck_sn, link: row.truck_sn ? ['/', this.siteInfo.customer_id, this.siteInfo.id, row.mac_address, 'performance'] :null },
				_voltage: {value: row._voltage},
				battery_capacity: {value: row.battery_capacity},
				_installation_date_ms: {value: row._installation_date_ms },
				last_connect_time_formatted: {value: row.last_connect_time_formatted },
				last_connected_in: { value: row.last_connected_in, sortValue: moment().utc().unix() - +row.last_connect_time },
				last_longitude: {value: row.last_longitude},
				last_latitude: {value: row.last_latitude},
				connectivity_verfication_status_formatted: {value: row.connectivity_verfication_status_formatted, link: row.connectivity_verfication_result && row.connectivity_verfication_result.report_id? ['/', 'admin-panel', 'connectivity-verification-log', row.connectivity_verfication_result?.report_id] : null},
				shipment_quality_result_formatted: {value: row.shipment_quality_result_formatted, link: row.shipment_quality_result && row.shipment_quality_result.report_id? ['/', 'management', 'shipment-quality-history', row.shipment_quality_result?.report_id] : null}
			}
			filteredBattlinkDevices.push(rowData);
		});
		this.installedBattlinkDevicesReportsConfig.data = filteredBattlinkDevices;
	}

	prepareIotemeterInstalledWidget() {
		let devicesGridCols: ColumnsConfig[] = [
			{ key: "serial_number", name: this.translateService.instant("iotemeter.devices.iotemeter_sn"), type: 'link' },
		];

		devicesGridCols.push(
			{ key: 'iotemeter_id', name: this.translateService.instant("devices.iotemeter_id"), type: 'string' },
			{ key: 'iotemeter_model', name: this.translateService.instant("iotemeter.devices.iotemeter_model"), type: 'string' }
		);

		if (this.usersService.hasAccessPermission({ permission: this.permissions }, 'basic_setup')) {
			devicesGridCols.push (
				{ key: 'panel_id', name: this.translateService.instant('iotemeter.devices.panel_equipment'), type: 'string'},
				{ key: 'load_id', name: this.translateService.instant('iotemeter.devices.load_id'), type: 'string' },
				{ key: "_installation_date_ms", name: this.translateService.instant("iotemeter.devices.installation_date"), type: 'timestamp', dateFormat: 'MM/DD/YYYY' },
			);
		}
		
		devicesGridCols.push(
			{ key: 'load_type', name: this.translateService.instant("iotemeter.devices.load_type_equipment"), type: 'string' }
		);

		if (this.usersService.hasAccessPermission({ permission: this.permissions }, 'noc')) {
			devicesGridCols.push(
				{ key: "fw_version", name: this.translateService.instant("iotemeter.devices.firmware_version"), type: 'string' },
			);
		}

		devicesGridCols.push(
			{ key: "last_connect_time_formatted", name: this.translateService.instant("iotemeter.devices.last_connect_time"), type: 'date_with_ref' },
			{ key: 'last_connected_in', name: this.translateService.instant('iotemeter.devices.last_connected_in'), type: "string" },
		);

		if (this.usersService.hasAccessPermission({ permission: this.permissions }, 'noc')) {
			devicesGridCols.push(
				{ key: "connectivity_verfication_status_formatted", name: this.translateService.instant("iotemeter.devices.passed_connectivity_verification"), type: 'action_link' },
				{ key: "shipment_quality_result_formatted", name: this.translateService.instant("iotemeter.devices.passed_shipment_quality"), type: 'action_link' },
			);
		}

		devicesGridCols.push(
			{ key: 'consumed_energy', name: this.translateService.instant("iotemeter.devices.consumed_energy"), type: 'number' }
		);

		this.common.applyTimeSourceTooltips(devicesGridCols, this.timeSourceByColumn);
		this.installedIotemeterDeviceTableConfig.column = devicesGridCols;
		let decimalPipe: DecimalPipe = new DecimalPipe("en-US");

		let meteredDevicesInfo = [];
		[...this.meteredDevices].forEach((row) => {
			let rowData: TableData = {
				serial_number: {value: row.serial_number, link: row.serial_number ? ['/', this.siteInfo.customer_id, this.siteInfo.id, row.mac_address, 'performance'] :null },
				iotemeter_id: {value: '-'}, //todo
				iotemeter_model: {value: this.getImModel(row.sct_device_type)},
				panel_id: {value: row.power_view_sn},
				load_id: {value: row.power_view_id},
				_installation_date_ms: {value: row._installation_date_ms },
				load_type: { value: row.load_type },
				fw_version: { value: row.fw_version },
				last_connect_time_formatted: {value: row.last_connect_time_formatted },
				last_connected_in: { value: row.last_connected_in, sortValue: moment().utc().unix() - +row.last_connect_time },
				connectivity_verfication_status_formatted: {
					value: row.connectivity_verfication_status_formatted, 
					link: row.connectivity_verfication_result && row.connectivity_verfication_result.report_id ? [''] : null,
					action: row.connectivity_verfication_result?.report_id ? () => {window.open(`${this.imDomain}/#/admin-panel/connectivity-verification-log`, '_blank')} : null
				}, 
				shipment_quality_result_formatted: {
					value: row.shipment_quality_result_formatted,
					link: row.shipment_quality_result && row.shipment_quality_result.report_id? ['']  : null,
					action: row.shipment_quality_result?.report_id ? () => {window.open(`/management/receiving-shipment-history/${row.shipment_quality_result.report_id}`, '_blank')} : null
				}, 
				consumed_energy: {value: decimalPipe.transform(row.consumed_energy, '1.2-2')},
			}
			meteredDevicesInfo.push(rowData);
		});
		this.installedIotemeterDeviceTableConfig.data = meteredDevicesInfo;
	}

	prepareBatteryInventoryReport() {
		let filteredData = [];
		[...this.allBattlinkDevices].forEach((row) => {
			let rowData: TableData = {
				truck_id: { value: row.truck_id},
				truck_sn: { value: row.truck_sn, link: row.truck_sn ? ['/', this.siteInfo.customer_id, this.siteInfo.id, row.mac_address, 'performance'] : null },
				truck_manufacturer: { value: row.truck_manufacturer },
				_voltage: {value: row._voltage},
				battery_capacity: {value: row.battery_capacity},
				truck_manufacturing_date: {value: row.truck_manufacturing_month + '/' + row.truck_manufacturing_year},
				last_longitude: {value: row.last_longitude},
				last_latitude: {value: row.last_latitude},
				last_pm_date: {value: row.last_pm_date*1000},
				battery_life_remainig_yrs: {value: row.battery_life_remainig_yrs},
				battery_life_remaining_ah: {value: row.battery_life_remaining_ah}
			}
			filteredData.push(rowData);
		});
		this.batteryInventoryReport.data = filteredData;
	}

	prepareBatteryReplacementReport() {
		const enrichedBatteries = this.allBattlinkDevices.map(battery => this.batteriesReplacementFormatData(battery));
		return this.applyBatteryReplacementFilters(enrichedBatteries);
	}

	batteriesReplacementFormatData(battery) {
		const lifeData = this.deviceService.getBatteryRemainingLifeData(battery);
		const maxLifeYears = battery.charger_type === this.deviceService.chargerTypes.Fast ? 4 : 5;
		const actualYearsRemaining = (lifeData.percentLifeRemainingYears / 100) * maxLifeYears;
		return {
			...battery,
			lifeRemainingYears: lifeData.percentLifeRemainingYears,
			lifeRemainingAh: lifeData.percentLifeRemainingAh,
			_actualYearsRemaining: actualYearsRemaining
		};
	}

	applyBatteryReplacementFilters(data: any[]): any[] {
		return data.filter(battery => {
			const actualYearsRemaining = battery._actualYearsRemaining;

			let yearFilterPassed = true;
			if (this.selectedBatteryYearFilter !== 'all') {
				const upperBound = +this.selectedBatteryYearFilter;
				const lowerBound = upperBound - 1;
				yearFilterPassed = actualYearsRemaining <= upperBound && actualYearsRemaining > lowerBound;
			}
			const capacityFilterPassed = this.selectedBatteryCapacityFilter == 'all' || battery.lifeRemainingAh <= +this.selectedBatteryCapacityFilter;
			return yearFilterPassed && capacityFilterPassed;
		});
	}

	getBatteryReplacementReportData() {
		let filteredData = [];
		const batteryReplacementData = this.prepareBatteryReplacementReport();
		// sort filter on remaining years closer to the maxLifeYear (4 or 5).
		batteryReplacementData.sort((a, b) => {
			const batteryA = Number(a.lifeRemainingYears) || 0;
			const batteryB = Number(b.lifeRemainingYears) || 0;
			return batteryA - batteryB;
		});

		filteredData = batteryReplacementData.map(row => ({
			truck_id: { value: row.truck_id },
			truck_sn: {
				value: row.truck_sn,
				link: row.truck_sn ? ['/', this.siteInfo.customer_id, this.siteInfo.id, row.mac_address, 'performance'] : null
			},
			truck_manufacturer: { value: row.truck_manufacturer },
			_voltage: { value: row._voltage },
			battery_capacity: { value: row.battery_capacity },
			truck_manufacturing_date: { value: row.truck_manufacturing_month + '/' + row.truck_manufacturing_year },
			battery_life_years: {value: row._actualYearsRemaining?.toFixed(2) },
			battery_life_remainig_yrs: { value: row.battery_life_remainig_yrs },
			battery_life_remaining_ah: { value: row.battery_life_remaining_ah }
		}));

		this.batteryReplacementReport.data = filteredData;
	}

	changeBatteryReplacementYearsFilter(value) {
		this.selectedBatteryYearFilter = value;
		this.getBatteryReplacementReportData();
	}

	changeBatteryReplacementCapacityFilter(value) {
		this.selectedBatteryCapacityFilter = value;
		this.getBatteryReplacementReportData();
	}

	prepareBatterySummaryReport() {
		const tableData = [];
		this.batterySummaryUsage.data = [];

		if (!this.allBattlinkDevices.length)
			return;

		let filteredDevices = this.allBattlinkDevices;
		if (this.selectedBatterySummaryVoltageFilter != 'all')
			filteredDevices = filteredDevices.filter((device) => device._voltage == this.selectedBatterySummaryVoltageFilter);

		if (this.selectedBatterySummaryCapacityFilter != 'all')
			filteredDevices = filteredDevices.filter((device) => device.battery_capacity == this.selectedBatterySummaryCapacityFilter);

		// A battery installed after the selected period's own end date - or with no installation date
		// recorded - is not yet installed for that period and should not get a row. Read the real end
		// date per period (e.g. "last_year" ends on last Dec 31, not yesterday) instead of assuming
		// every period ends at yesterday, which let a battery installed after last year ended still
		// pass the check for "last_year".
		const periodEnd = Math.floor((this.common.getDateRange(this.selectedBatterySummaryPeriodFilter).to?.getTime() || 0) / 1000);
		filteredDevices = filteredDevices.filter((device) => device.installation_date && device.installation_date <= periodEnd);

		for (const device of filteredDevices) {
			let siteDevicesAnalytics = this.siteDevicesAnalyticsData[device.mac_address] || {};
			siteDevicesAnalytics = siteDevicesAnalytics[this.selectedBatterySummaryPeriodFilter] || {};
			tableData.push({
				truck_id: { value: device.truck_id },
				truck_sn: { value: device.truck_sn, link: device.truck_sn ? ['/', this.siteInfo.customer_id, this.siteInfo.id, device.mac_address, 'performance'] : null },
				charge_hours: { value:  +(siteDevicesAnalytics?.charge_time_for_battery / 3600 ||0).toFixed(0)},
				inuse_hours: { value:  +(siteDevicesAnalytics?.battery_inuse_time/3600 || 0).toFixed(2)},
				idle_hours: { value:  +(siteDevicesAnalytics?.idle_time/3600 || 0).toFixed(2)},
				charge_ah: { value: +(siteDevicesAnalytics?.total_as_from_charge_events_only/3600 || 0).toFixed(2) },
				inuse_ah: { value: +(siteDevicesAnalytics?.total_battery_as_from_inuse_events_only/3600 || 0).toFixed(2) },
				charge_kwh: { value: +(siteDevicesAnalytics?.total_charge_ws_from_charge_events_only_for_battery / 1000 / 3600 || 0).toFixed(2) },
				inuse_kwh: { value: +(siteDevicesAnalytics?.total_battery_ws_from_inuse_events_only / 1000 / 3600 || 0).toFixed(2) },
			});
		}

		this.batterySummaryUsage.data = tableData;
	}

	fillCsvFileHeadersInfo() {
		const exportedCsvFileHeader = this.common.getCsvFileHeadersInfo({
			customerName: this.siteInfo.customer_name,
			siteName: this.siteInfo.name,
			includeSpacing: false
		});

		const reports = [
			"summaryTruckUsageReport",
			"installedIotahDeviceTableConfig",
			"installedChargerDeviceTableConfig",
			"chargLinkQuarterlyTableConfig",
			"truckInventoryReport",
			"chargerInventoryReportTableConfig",
			"lowChargerUtilizationReportTableConfig",
			"batteryInventoryReport",
			"installedBattlinkDevicesReportsConfig",
			"batteryReplacementReport",
			"batterySummaryUsage"
		];

		reports.forEach(key => {
			this[key].config.csvFileHeaderInfo = exportedCsvFileHeader;
		});
	}

	regenerateBrmToken(regenerate: boolean) {
		if (!regenerate && this.siteInfo.brm_public_token) {
			this.brmValidToken = true;
			return;
		}

		this.brmValidToken = false;
		const token = this.siteInfo.id + uuid();

		this.sitesService.regenerateBrmPublicToken(this.siteInfo.id, token).subscribe(() => {
			this.siteInfo.brm_public_token = token;
			this.brmValidToken = true;
		});
	}

	showRequestPasswordButton(): boolean {
		const hasNOCPermission = this.usersService.userHasNOCAccess() || this.usersService.hasAccessPermission(this.sitePermissions, 'noc');
		const hasSiteLevelPassword = this.siteInfo?.password_mode === 'site_level';
		return hasNOCPermission && hasSiteLevelPassword;
	}

	requestRevealPassword() {
		this.revealPasswordConfirmModal.show();
	}

	confirmRevealPasswordRequest() {
		this.revealPasswordConfirmModal.hide();
		const customer_id = this.siteInfo.customer_id;
		const site_id = this.siteInfo.id;
		const request_type = 'site';
		this.sitesService.requestRevealPassword(site_id, customer_id, request_type).subscribe((response: any) => {
			if (response.api_status == 2)
				return this.notificationMessage.setMessage('translate|password_reveal.pending_request_exists', { clearOnXTimeNavigate: 1 });
		
			this.notificationMessage.setMessage('translate|password_reveal.request_submitted', {
					type: 'success',
					clearOnXTimeNavigate: 1
			});	
		});
	}
	getImModel(sct_device_type: number) {
		switch (sct_device_type) {
			case DeviceFactory.types.ioTEmeterSp1:
				return 'SP1';
			case DeviceFactory.types.ioTEmeterSp3:
				return 'SP3';
			case DeviceFactory.types.ioTEmeter:
				return 'Pro';
			case DeviceFactory.types.ioTEmeterEdge:
				return 'Edge';
		}
	}
}
